export function getLanguageCode(locale) {
  return locale ? locale.trim().split(/-|_/)[0].toLowerCase().substr(0, 2) : undefined;
}
